import $ from 'jquery'
import { tns } from 'tiny-slider/src/tiny-slider.module'

function panelCarousel() {
  function generatePagination(el, current, total) {
    const paginationEl = el
    paginationEl.innerHTML = `${current}|${total}`
  }

  function pagination(info, el) {
    // Not showing cloned item count.
    // Because of the looping behaviour there are cloned slides
    // and the index will count them for the last slide.
    if (info.index <= info.slideCount) {
      generatePagination(el, info.index, info.slideCount)
    }
  }

  [].forEach.call([...document.querySelectorAll('[data-panel]')], (el) => {
    const carouselNav = el.nextElementSibling
    const nextButton = carouselNav.querySelector('[data-panel-next]')
    const prevButton = carouselNav.querySelector('[data-panel-prev]')
    const paginationEl = carouselNav.querySelector('[data-panel-pagination]') 

    const carousel = tns({
      container: el,
      items: 1,
      nav: false,
      mouseDrag: true,
      arrowKeys: true,
      autoHeight: false,
      nextButton,
      prevButton,
      responsive: {
        500: {
          items: 2
        },
        768: {
          items: 3
        }
      },
      onInit(info) {
        generatePagination(paginationEl, info.index, info.slideCount);
        $('.tns-slide-active:eq( 1 )').addClass('active-center');
      },
    }) 

    carousel.events.on('indexChanged', (info) => { 
      pagination(info, paginationEl);
      $('.tns-slide-active.active-center').removeClass('active-center');
      $('.tns-slide-active:eq( 1 )').addClass('active-center');
    }) 
  }) 

  $('.tns-item').find('img').wrap('<div class="item-wrapper"></div>');
  
}

export default panelCarousel